<h4 class="title">Portfolio</h4>

<div class="card-box">
    <div class="row" style="padding: 0px 0px 23px 10px;">
       
        <div class="col-md-4">
            <h5 class="form-lable">Portfolio Type:</h5>
            <p-dropdown [options]="types" [(ngModel)]="cli_type" placeholder="Select" optionLabel="y" [showClear]="true"></p-dropdown>
           
        </div>
        <div class="col-md-4">
            <h5 class="form-lable">Portfolio Name:</h5>
            <input type="text" pInputText [(ngModel)]="Name" placeholder="Client Name">
        </div>
        <div class="col-md-4">
            <h5 class="form-lable">Portfolio Data set:</h5>
            <p-dropdown [options]="types" [(ngModel)]="cli_type" placeholder="Select" optionLabel="y" [showClear]="true"></p-dropdown>
           
        </div>
        <div class="col-md-12 mt-20">
            <button type="button" class="btn btn-primary">Add</button>
            <button type="button" class="btn btn-primary btn-bg-blue" (click)="cancel()">Cancel</button>
        </div>

    </div>
</div>